import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Row,
  Col,
  CardHeader,
  Breadcrumb,
  BreadcrumbItem,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import ProductHydro from './ProductHydro';
import HydrocarbonCondensat from './HydrocarbonCondensat';
import useTenderOpeningTabVisibility from '../hooks/useTenderOpeningTabVisibility';

const TABS = [
  {
    id: 'product-hydro',
    label: 'Product Hydro',
    icon: 'ri-drop-line',
    component: ProductHydro,
  },
  {
    id: 'hydrocarbon-condensat',
    label: 'Hydrocarbon & Condensate',
    icon: 'ri-test-tube-line',
    component: HydrocarbonCondensat,
  },
];

const TenderOpening = () => {
  const [activeTab, setActiveTab] = useState('product-hydro');
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const {
    onlyKPI,
    onlyPPN,
    showProductHydro,
    showHydroCondensate,
    defaultTab,
  } = useTenderOpeningTabVisibility();

  const visibleTabs = TABS.filter(tab => {
    if (tab.id === 'product-hydro') return showProductHydro;
    if (tab.id === 'hydrocarbon-condensat') return showHydroCondensate;
    return true;
  });

  useEffect(() => {
    if (!visibleTabs.find(tab => tab.id === activeTab)) {
      setActiveTab(visibleTabs[0]?.id || defaultTab);
    }
    if (onlyKPI) {
      setActiveTab('hydrocarbon-condensat');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onlyKPI, onlyPPN]);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <React.Fragment>
      <div className='email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
        <div className='email-content minimal-border'>
          <div className='p-4 pb-0'>
            <div className='border-bottom border-bottom-dashed'>
              <Row className='mt-n2 mb-1 mb-sm-0'>
                <div className='col-sm order-3 order-sm-2'>
                  <div className='hstack gap-sm-1 align-items-center flex-wrap email-topbar-link'>
                    <h5 className='card-title mb-0 flex-grow-1'>
                      <Breadcrumb listClassName='p-3 py-2 bg-light'>
                        <BreadcrumbItem>
                          <Link to='/dashboard'>Home</Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem>
                          <Link to='/apps-tenderopening/view'>
                            Tender Opening
                          </Link>
                        </BreadcrumbItem>
                        <BreadcrumbItem active>View</BreadcrumbItem>
                      </Breadcrumb>
                    </h5>
                  </div>
                </div>
                <div className='col-auto order-2 order-sm-3'>
                  <div className='d-flex gap-sm-1 email-topbar-link'>
                    <button
                      type='button'
                      className='btn btn-ghost-secondary material-shadow-none btn-icon btn-sm fs-16'
                      onClick={handleRefresh}
                      title='Refresh data'
                    >
                      <i className='ri-refresh-line align-bottom'></i>
                    </button>
                  </div>
                </div>
              </Row>

              <Row className='align-items-end mt-1 mb-1'>
                <Col xs={12}>
                  <CardHeader className='border-0'>
                    <h5 className='card-title mb-0 text-uppercase'>
                      Tender Opening
                    </h5>
                  </CardHeader>
                </Col>
              </Row>
            </div>

            <div className='message-list-content mx-n4 px-4 message-list-scroll'>
              <Nav tabs className='nav-tabs-custom nav-primary mt-3 mb-0'>
                {visibleTabs.map(tab => (
                  <NavItem key={tab.id}>
                    <NavLink
                      className={classnames('cursor-pointer', {
                        active: activeTab === tab.id,
                      })}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      <i className={`${tab.icon} align-middle me-1`}></i>
                      <span className='fw-semibold'>{tab.label}</span>
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>

              <TabContent activeTab={activeTab} className='pt-3'>
                {visibleTabs.map(tab => {
                  if (activeTab !== tab.id) return null;

                  const TabComponent = tab.component;
                  return (
                    <TabPane key={tab.id} tabId={tab.id}>
                      <TabComponent refreshTrigger={refreshTrigger} />
                    </TabPane>
                  );
                })}
              </TabContent>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default React.memo(TenderOpening);
